webpackJsonp([271073383855010],{

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.7336fb12.svg";

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\t\tcolumn-count: initial;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t"], ["\n\t\tcolumn-count: initial;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\t\twidth: 360px;\n\t\tmax-width: 100%;\n\t"], ["\n\t\twidth: 360px;\n\t\tmax-width: 100%;\n\t"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(26);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(23);
	
	var _components = __webpack_require__(11);
	
	var _BlockSectionOpening = __webpack_require__(222);
	
	var _BlockSectionOpening2 = _interopRequireDefault(_BlockSectionOpening);
	
	var _settings = __webpack_require__(27);
	
	var _themes = __webpack_require__(15);
	
	var _global = __webpack_require__(6);
	
	var _logo = __webpack_require__(84);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _type = __webpack_require__(10);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_Component) {
		_inherits(Profile, _Component);
	
		function Profile() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Profile);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				sections: [],
				history: [],
				history_title: null,
				history_introduction: null
			}, _this.componentWillMount = function () {
				_this.props.fetchSettings();
			}, _this.componentDidMount = function () {
				var data = _this.props.data.wordpressProfile;
	
				_this.setState({
					sections: JSON.parse(data.acf_json).sections,
					history: JSON.parse(data.acf_json).history,
					history_title: JSON.parse(data.acf_json).history_title,
					history_introduction: JSON.parse(data.acf_json).history_introduction
				});
			}, _this.renderBlocks = function (blocks) {
				return blocks.map(function (block, i) {
					return _react2.default.createElement(_components.Block, _extends({
						layout: block.acf_fc_layout,
						key: i
					}, block));
				});
			}, _this.renderSections = function () {
				var sections = _this.state.sections;
	
	
				return sections.map(function (section, i) {
					var blocks = section.blocks;
	
					if (section.display_section && section.blocks) {
						return _react2.default.createElement(_components.Section, {
							key: i,
							blocks: blocks,
							section: section
						});
					}
				});
			}, _this.renderHistoryItems = function () {
				var history = _this.state.history;
	
	
				if (history) {
					return history.map(function (item, i) {
						return _react2.default.createElement(
							HistoryItem,
							{
								key: i
							},
							_react2.default.createElement(Heading, {
								dangerouslySetInnerHTML: { __html: item.heading }
							}),
							_react2.default.createElement(Description, {
								dangerouslySetInnerHTML: { __html: item.details }
							})
						);
					});
				}
			}, _this.renderHistory = function () {
				var _this$state = _this.state,
				    history_title = _this$state.history_title,
				    history_introduction = _this$state.history_introduction;
	
	
				return _react2.default.createElement(
					History,
					null,
					_react2.default.createElement(_BlockSectionOpening2.default, {
						title: history_title,
						paragraph: history_introduction
					}),
					_react2.default.createElement(
						HistoryItems,
						null,
						_this.renderHistoryItems()
					)
				);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Profile.prototype.render = function render() {
			var data = this.state.data;
	
			var splashActive = this.props.settings.splashActive;
	
			return _react2.default.createElement(
				Wrapper,
				{
					active: splashActive == false
				},
				_react2.default.createElement(_components.MetaTags, {
					title: "Paul Conrad Architects \u2014 Profile"
				}),
				this.renderSections(),
				this.renderHistory(),
				_react2.default.createElement(_components.Footer, {
					title: 'Profile',
					pageURL: (0, _utils.isClient)() ? window.location.href : '',
					backLink: '/',
					backLinkText: 'Back to Home'
				})
			);
		};
	
		return Profile;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
		displayName: "Profile__Wrapper",
		componentId: "sc-1lt7i10-0"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;z-index:2;overflow-x:hidden;transition:all 0.75s ease;transition-delay:0.4s;will-change:transform;transform:translateY(100px);opacity:0;", ""], function (props) {
		if (props.active) return (0, _styledComponents.css)(["transform:translateY(0);opacity:1;"]);
	});
	
	// Shared
	
	var Heading = _styledComponents2.default.div.withConfig({
		displayName: "Profile__Heading",
		componentId: "sc-1lt7i10-1"
	})([""]);
	var Description = _styledComponents2.default.div.withConfig({
		displayName: "Profile__Description",
		componentId: "sc-1lt7i10-2"
	})([""]);
	
	// History
	
	var History = _styledComponents2.default.div.withConfig({
		displayName: "Profile__History",
		componentId: "sc-1lt7i10-3"
	})(["display:flex;flex-direction:column;align-items:center;width:100%;margin-bottom:15rem;padding-top:15rem;border-top:1px solid rgba(0,0,0,0.08);"]);
	
	var HistoryItems = _styledComponents2.default.div.withConfig({
		displayName: "Profile__HistoryItems",
		componentId: "sc-1lt7i10-4"
	})(["", ";column-count:2;column-gap:5rem;margin-top:10rem;", ""], _global.innerContainer, _utils.media.tablet(_templateObject));
	
	var HistoryItem = _styledComponents2.default.div.withConfig({
		displayName: "Profile__HistoryItem",
		componentId: "sc-1lt7i10-5"
	})(["break-inside:avoid;&:not(:first-child){margin-top:3rem;}", " ", "{&,*{", ";}}", "{margin-top:1rem;&,*{", ";text-indent:0!important;}}"], _utils.media.tablet(_templateObject2), Heading, _type.paragraph, Description, _type.caption);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
		return {
			fetchSettings: function fetchSettings() {
				dispatch((0, _settings.fetchSettings)());
			},
			updateSettings: function (_updateSettings) {
				function updateSettings(_x) {
					return _updateSettings.apply(this, arguments);
				}
	
				updateSettings.toString = function () {
					return _updateSettings.toString();
				};
	
				return updateSettings;
			}(function (setting) {
				dispatch(updateSettings(setting));
			})
		};
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
		return {
			settings: state.settings.settings
		};
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Profile);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-profile-js-4400131092d085f6549e.js